module.exports = __webpack_public_path__ + "assets/img/cases.9838d504.png";